/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {html} from 'htm/preact';

/*:: type Props = {
  +liked: ?boolean,
  +onChange?: (liked: boolean) => void,
}; */

export function Rating({liked, onChange} /*: Props */) /*: React$Node */ {
  return html`
    <div
      className=${`like${liked ? ' -full' : ''}`}
      onClick=${onChange && onChange.bind(null, !liked)}
    />
  `;
}

export function RatingPlaceholder() /*: React$Node */ {
  return html`<div className="like -placeholder" />`;
}
